import { useEffect, useState } from "react";

type Props = {
  content: string;
  mobilePreviewLength?: number;
};

const ExpandableRecommendation = ({
  content,
  mobilePreviewLength = 140,
}: Props) => {
  const [expanded, setExpanded] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 639px)");
    const updateViewport = () => {
      setIsMobile(mediaQuery.matches);
      if (!mediaQuery.matches) setExpanded(false);
    };

    updateViewport();
    mediaQuery.addEventListener("change", updateViewport);
    return () => mediaQuery.removeEventListener("change", updateViewport);
  }, []);

  const canExpand = isMobile && content.length > mobilePreviewLength;
  const visibleContent =
    canExpand && !expanded
      ? `${content.slice(0, mobilePreviewLength).trimEnd()}…`
      : content;

  return (
    <div>
      <blockquote className="whitespace-pre-line italic leading-relaxed text-gray-300">
        “{visibleContent}”
      </blockquote>
      {canExpand && (
        <button
          type="button"
          className="mt-3 text-sm text-teal hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal"
          aria-expanded={expanded}
          onClick={() => setExpanded((current) => !current)}
        >
          {expanded ? "Hide" : "Expand"}
        </button>
      )}
    </div>
  );
};

export default ExpandableRecommendation;
